// redirect-supersede-done-tickets.ts
//
// Split out of directive-redirect-application.ts (phase 06f R2: that file sat
// at 196/200 lines before PLAN.md wiring). Behaviour unchanged (test 28).
//
// Scope narrowing: a ticket already "done" is demoted to "superseded" — it
// must NOT continue to count as done toward mission completion (test 28).
// Distinct from proposal-applier's own "supersede" op because the caller
// names tickets directly (redirect free text -> ticket ids resolved by the
// controller), not via a ticket_id+expected_revision transaction entry.
//
// Một amend ở vòng trước có thể đã ép ticket "done" -> "todo" (guard
// acceptance của proposal-applier.ts) — đọc `currentStatus` trần thì
// supersede trượt. Nhưng KHÔNG đọc `inputStatus` trần thay thế
// (code-reviewer 260922 H-review1): một `op: "cancel"` cùng directive sẽ bị
// "superseded" đè lên "cancelled". Điều kiện dưới nhận đúng MỘT chuyển dịch
// "done" (đầu vào) -> "todo" (do guard đặt), còn lại đọc `currentStatus`.

/** Marks each named done ticket `superseded` in `currentStatus` (mutated) and records it in `touched`. */
export function supersedeDoneTickets(
  ticketIds: readonly string[],
  inputStatus: Readonly<Record<string, string>>,
  currentStatus: Record<string, string>,
  touched: Set<string>,
): void {
  for (const ticketId of ticketIds) {
    const forcedTodoByAcceptanceGuard =
      currentStatus[ticketId] === "todo" && inputStatus[ticketId] === "done";
    if (currentStatus[ticketId] === "done" || forcedTodoByAcceptanceGuard) {
      currentStatus[ticketId] = "superseded";
      touched.add(ticketId);
    }
  }
}
